import { render, staticRenderFns } from "./AmountDigitText.vue?vue&type=template&id=e621a570&scoped=true"
import script from "./AmountDigitText.vue?vue&type=script&lang=js"
export * from "./AmountDigitText.vue?vue&type=script&lang=js"
import style0 from "./AmountDigitText.vue?vue&type=style&index=0&id=e621a570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e621a570",
  null
  
)

export default component.exports